<mat-card>
  <h2 translate>title.financing.amount</h2>
  <form [formGroup]="financingAmountDataForm">
    <mat-grid-list cols="15" rowHeight="90px">
      <!--Row-->
      <mat-grid-tile colspan="8">
        <scf-custom-select-search
          fxFlex="100"
          formControlName="lineProduct"
          [id]="'lineProductUptakeData'"
          [dataInput]="lineProductList"
          [placeholder]="'request.lineProduct'"
          [isRequired]="true"
          [showErrors]="financingAmountDataForm?.controls?.lineProduct?.invalid"
          (selectionChange)="onLineProductSelected($event)"
        ></scf-custom-select-search>
      </mat-grid-tile>
      <mat-grid-tile colspan="7">
        <scf-custom-select-search
          fxFlex="100"
          formControlName="product"
          [id]="'productUptakeData'"
          [dataInput]="productList"
          [placeholder]="'request.product'"
          [isRequired]="true"
          [showErrors]="financingAmountDataForm?.controls?.product?.invalid"
        ></scf-custom-select-search>
      </mat-grid-tile>
      <mat-grid-tile colspan="4">
        <mat-form-field fxFlex="100" appearance="outline">
          <mat-label translate>requestDataUptake.priceProduct</mat-label>
          <input
            id="priceProductFinancingAmount"
            #priceProduct
            matInput
            formControlName="priceProduct"
            (change)="transformAmount($event, priceProduct)"
            (keypress)="numberOnly($event, priceProduct)"
            (blur)="calculateStart($event)"
            autocomplete="off"
            maxlength="20"
            required
          />
          <mat-error *ngIf="financingAmountDataForm.controls.priceProduct.errors?.max || priceValid == false" translate
            >field.price.notAllowed</mat-error
          >
          <mat-error
            *ngIf="financingAmountDataForm.controls.priceProduct.errors?.required && priceValid == true"
            translate
            >field.required</mat-error
          >
        </mat-form-field>
      </mat-grid-tile>
      <mat-grid-tile colspan="4">
        <mat-form-field fxFlex="100" appearance="outline">
          <mat-label translate>request.requestedAmount</mat-label>
          <input
            id="requestedAmountFinancingAmount"
            #requestedAmount
            matInput
            formControlName="requestedAmount"
            (change)="transformAmount($event, requestedAmount)"
            (keypress)="numberOnly($event, requestedAmount)"
            (blur)="calculateStart($event)"
            required
            autocomplete="off"
            maxlength="21"
          />
          <mat-error
            *ngIf="financingAmountDataForm.controls.requestedAmount.errors?.max || amountValid == false"
            translate
            >field.amount.notAllowed</mat-error
          >
          <mat-error *ngIf="financingAmountDataForm.controls.requestedAmount.hasError('AmountInvalid')" translate>
            field.amount.invalid
          </mat-error>
          <mat-error
            *ngIf="financingAmountDataForm.controls.requestedAmount.errors?.required && amountValid == true"
            translate
          >
            field.required
          </mat-error>
          <mat-error *ngIf="financingAmountDataForm.controls.requestedAmount.hasError('repsolAmountInvalid')" translate>
            field.repsolAmountInvalid
          </mat-error>
          <mat-error
            *ngIf="
              financingAmountDataForm.controls.requestedAmount.hasError('MaxAmount') &&
              !(typeBalance?.balance === 'S' && operative?.value !== null)
            "
          >
            {{ 'field.amount.maxAmount' | translate }} {{ maxAmount }}
          </mat-error>
        </mat-form-field>
      </mat-grid-tile>
      <mat-grid-tile colspan="4">
        <mat-form-field fxFlex="100" appearance="outline">
          <mat-label translate>request.start</mat-label>
          <input id="startFinancingAmount" #start matInput formControlName="start" readonly autocomplete="off" />
        </mat-form-field>
      </mat-grid-tile>

      <!-- end row view mode -->
      <mat-grid-tile colspan="3" *ngIf="mode !== 'view' && this.typeBalance?.balance === 'S'">
        <div fxFlex="100" class="request__button-calculate">
          <button
            id="calculateFinanceButtonAmountData"
            color="primary"
            fxFlex="100"
            mat-flat-button
            (click)="showRequestData()"
          >
            <mat-label translate>CONTINUAR</mat-label>
          </button>
        </div>
      </mat-grid-tile>
      <mat-grid-tile colspan="2" *ngIf="priceValueRef != null">
        <mat-label class="alignRef">{{ 'requestDataAutos.valorRef' | translate }} {{ priceValueRef }}</mat-label>
      </mat-grid-tile>
    </mat-grid-list>
  </form>
</mat-card>
